export default class MemberService {
    orderJobs = (provider, data) => {
        return axios.post(`/providers/${provider}/jobs/order`, data);
    };
}
